import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propArrayShape, propArrayStr, propBool, propFunc, propStr, propShape, propNumber, } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import { useSlideSearchCommonSelect } from '../../../../helpers/use/proffit_search/common/useSlideSearchSelect';
import TransitionHoc from '../../../Ui/Transition/TransitionHoc';
import ActionPptxButton from '../Action/Pptx/ActionPptxButton';
import ActionSaveButton from '../Action/Save/ActionSaveButton';
import ActionShareButton from '../Action/Share/ActionShareButton';
const ItemStickyInner = (props) => {
    const { enableDomains, folders, isFree, noShareMemberOptionsMessage, 
    // 選択状態
    onClickLockItem, onClickPptx, 
    // PPTX操作用
    onClickSaveFolder, 
    // フォルダ操作用
    onClickSelectDelete, onLoadShareMemberOptions, onSubmitCreateFolder, 
    // 共有操作用
    onSubmitShare, profile, selectSlides, transitionState, } = props;
    const { isBlockDownload, isBlockShare, isNotReadyPptx } = useSlideSearchCommonSelect.useSlideSearchCommonAllowAction(selectSlides);
    const checkedCount = selectSlides.length;
    return (_jsx("div", Object.assign({ className: clsx('sticky-footer slide_search_page animated-opacity', transitionState) }, { children: _jsxs("div", Object.assign({ className: 'footer-action' }, { children: [checkedCount > 0 && (_jsxs("div", Object.assign({ className: 'footer_file_select_box' }, { children: [_jsxs("div", Object.assign({ className: 'footer_file_select' }, { children: [_jsx("i", { className: 'footer_file_select_check' }), _jsx("span", Object.assign({ className: 'footer_file_select_text' }, { children: `${checkedCount}ファイル選択中` }))] })), _jsx("div", Object.assign({ className: 'footer_file_select' }, { children: _jsx("button", Object.assign({ className: 'footer_file_select_clear', onClick: onClickSelectDelete, type: 'button' }, { children: "\u5168\u89E3\u9664" })) }))] }))), _jsxs("div", Object.assign({ className: 'button_box_list' }, { children: [_jsx(ActionPptxButton, { buttonClassName: 'icon_box_border', isBlockDownload: isBlockDownload, isFree: isFree, isNotReadyPptx: isNotReadyPptx, onClickLockItem: onClickLockItem, onClickPptx: onClickPptx, position: 'bottom', selectSlides: selectSlides }), _jsx(ActionSaveButton, { buttonClassName: 'icon_box_border', className: 'footer_action_save_modal', folders: folders, onClickSaveFolder: onClickSaveFolder, onSubmitCreateFolder: onSubmitCreateFolder, selectSlides: selectSlides, showBg: true }), _jsx(ActionShareButton, { buttonClassName: 'icon_box_border', className: 'footer_action_share_modal', enableDomains: enableDomains, isBlockShare: isBlockShare, isFree: isFree, noShareMemberOptionsMessage: noShareMemberOptionsMessage, onClickLockItem: onClickLockItem, onLoadShareMemberOptions: onLoadShareMemberOptions, onSubmitShare: onSubmitShare, position: 'bottom', profile: profile, select2TooltipZIndex: 9999, selectSlides: selectSlides, showBg: true })] }))] })) })));
};
ItemStickyInner.propTypes = {
    enableDomains: propArrayStr().isRequired,
    // フォルダ操作用
    folders: propArrayShape().isRequired,
    isFree: propBool().isRequired,
    noShareMemberOptionsMessage: propFunc().isRequired,
    onClickLockItem: propFunc().isRequired,
    // PPTX操作用
    onClickPptx: propFunc().isRequired,
    onClickSaveFolder: propFunc().isRequired,
    onClickSelectDelete: propFunc().isRequired,
    // 共有操作用
    onLoadShareMemberOptions: propFunc().isRequired,
    onSubmitCreateFolder: propFunc().isRequired,
    onSubmitShare: propFunc().isRequired,
    profile: propShape().isRequired,
    // 選択状態
    selectSlides: propArrayShape().isRequired,
    // HOC
    transitionState: propStr().isRequired,
};
const ItemSticky = compose(TransitionHoc)(ItemStickyInner);
ItemSticky.propTypes = {
    enableDomains: propArrayStr().isRequired,
    // フォルダ操作用
    folders: propArrayShape().isRequired,
    isFree: propBool().isRequired,
    // HOC
    isShow: propBool().isRequired,
    noShareMemberOptionsMessage: propFunc().isRequired,
    onClickLockItem: propFunc().isRequired,
    // PPTX操作用
    onClickPptx: propFunc().isRequired,
    onClickSaveFolder: propFunc().isRequired,
    onClickSelectDelete: propFunc().isRequired,
    // 共有操作用
    onLoadShareMemberOptions: propFunc().isRequired,
    onSubmitCreateFolder: propFunc().isRequired,
    onSubmitShare: propFunc().isRequired,
    profile: propShape(),
    // 選択状態
    selectSlides: propArrayShape().isRequired,
    timeout: propNumber(),
};
ItemSticky.defaultProps = {
    profile: {},
    timeout: 500,
};
export default ItemSticky;
